export function getTreatmentCards(tx_cards) {
  return tx_cards.map(tx_card => ({
    id: tx_card._id,
    text: tx_card.name,
  }))
}
